import { getField } from "vuex-map-fields";

const userOptions = (state) => state.users.map((user) => ({
  label: user.fullname,
  value: user.id.toString(),
}));

const categoryOptions = (state) => Object.entries(state.categories).map(([key, value]) => ({
  label: value,
  value: key,
}));
const templateOptions = (state) => state.templates.map((template) => ({
  label: template.name,
  value: template.id,
}));

const activeTemplate = (state) => state.templates
  .find((template) => template.id == state.task.template);

const isEditing = (state) => !!state.task.id;
const activeCategory = (state) => state.categories[state.task.category_id];
export default {
  isEditing,
  activeCategory,
  templateOptions,
  userOptions,
  categoryOptions,
  activeTemplate,
  getField,
};
